import Item from 'antd/lib/form/FormItem';
import Switch from 'antd/lib/switch';

import QuestionMark from 'components/QuestionMark/QuestionMark';
import { questionMarks } from 'utils/constants/constants';

const MyStoreCustomizableBranding = () => (
  <>
    <h4 className="mb-4 mt-6">
      Allow Dropshippers To Ask For Customizable Branding
      <QuestionMark>{questionMarks.store.customizableBranding}</QuestionMark>
    </h4>
    <div className="flex items-center">
      No
      <Item name="isLogoInvoiceAllowed" className="mb-0 mx-1" valuePropName="checked">
        <Switch className="mx-2.5" />
      </Item>
      Yes
    </div>
  </>);

export default MyStoreCustomizableBranding;
